import {
    AllEvents,
    EntitledToView,
    PublicationType,
    RequiredAccess,
} from '@news-mono/web-common'
import { GetOffersResult } from '@west-australian-newspapers/subscription-offer-types'
import { Logger } from '@west-australian-newspapers/typescript-log'
import H from 'history'
import React from 'react'
import { LazyBreachWallContentWrapper } from './components/BreachWallContentWrapper/BreachWallContentWrapper.lazy'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import { StyledFeatureArticleBreachNotification } from './FeatureArticleBreach.styled'

export interface FeatureArticleBreachProps {
    requiredAccess: RequiredAccess
    location: H.Location
    commonElements: React.ReactElement<any>
    comments?: React.ReactElement<any>
    onEvent: (event: AllEvents) => void
    article: PublicationType
    log: Logger
    subscriptionOffers?: GetOffersResult
}

export const FeatureArticleBreach: React.FC<FeatureArticleBreachProps> = (
    props,
) => {
    const {
        commonElements,
        comments,
        requiredAccess,
        location,
        onEvent,
        article,
        log,
    } = props

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={article.slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                location,
                onEvent,
                article,
            )}
            entitled={() => {
                return (
                    <div>
                        {commonElements}
                        {props.children}
                        {comments}
                    </div>
                )
            }}
            notEntitled={() => {
                return (
                    <div>
                        {commonElements}
                        <StyledFeatureArticleBreachNotification>
                            <LazyBreachWallContentWrapper
                                publication={article}
                                requiredAccess={requiredAccess.level}
                                location={location}
                                onEvent={onEvent}
                                log={log}
                                initialOfferData={props.subscriptionOffers}
                            />
                        </StyledFeatureArticleBreachNotification>
                        {comments}
                    </div>
                )
            }}
        />
    )
}

FeatureArticleBreach.displayName = 'FeatureArticleBreach'
